<template>
	<v-app style="background-color: #f4fafa">
		<!-- Header -->
		<v-app-bar app flat dark height="74" class="header-bar">
			<v-img
				alt="Orixe Logo"
				:src="require('../../assets/Logo_Header_White.svg')"
				max-width="170"
				contain
			/>
			<div class="header-divider mx-4"></div>
			<span class="header-title">Incident Reporting Platform</span>
			<v-spacer></v-spacer>
			<v-btn outlined tile class="logout-btn" @click="logout">Log Out</v-btn>
		</v-app-bar>

		<v-main>
			<v-container class="page-container">
				<h1 class="page-title mb-4">Incident Reporting</h1>

				<div class="form-wrapper">
					<v-card outlined tile class="form-card pa-10">
						<h2 class="form-title text-center mb-8">Reporting Form</h2>

						<p class="intro-text">
							Use this form to report any incident, near miss, or concern you have
							observed or been involved in. Reporting helps us respond quickly,
							reduce risk, and improve how we work.
						</p>
						<p class="intro-text">
							Please select the type of incident, enter the date it happened, and
							describe what occurred in as much detail as you can. Include what
							happened, where, and who was involved, but only the facts. Do not
							include personal opinions or blame.
						</p>
						<p class="intro-text mb-10">
							Your report will be reviewed by the responsible manager, who will
							record the consequences and agree on actions. If you're unsure
							whether something counts as an incident, report it anyway.
						</p>

						<v-form ref="form" @submit.prevent="send">
							<v-alert v-if="error" type="error" dense class="mb-6">
								{{ error }}
							</v-alert>

							<v-select
								v-model="form.type"
								:items="incidentTypes"
								label="Type of Incident"
								outlined
								light
								color="teal darken-2"
								:rules="[rules.required]"
							></v-select>

							<v-text-field
								v-model="form.date"
								label="Date of Incident"
								type="date"
								outlined
								light
								color="teal darken-2"
								:max="today"
								:rules="[rules.required]"
							></v-text-field>

							<v-textarea
								v-model="form.description"
								label="Description"
								outlined
								light
								auto-grow
								rows="1"
								color="teal darken-2"
								:rules="[rules.required]"
							></v-textarea>

							<v-btn
								type="submit"
								dark
								depressed
								class="send-btn mt-2"
								:loading="loading"
							>
								<v-icon left small>fas fa-paper-plane</v-icon>
								Send
							</v-btn>
						</v-form>
					</v-card>
				</div>
			</v-container>
		</v-main>

		<v-snackbar v-model="snackbar" color="success" timeout="4000">
			Incident report sent. Thank you.
		</v-snackbar>
	</v-app>
</template>

<script>
import { riskAPI } from "../../api/csr/risk"

export default {
	name: "IncidentForm",

	data() {
		return {
			loading: false,
			error: null,
			snackbar: false,
			form: {
				type: null,
				date: null,
				description: ""
			},
			// Replace with the real incident types for your client
			incidentTypes: [
				"Injury",
				"Illness / Occupational Disease",
				"Near Miss",
				"Safety Concern / Unsafe Condition",
				"Fire / Explosion",
				"Chemical Spill / Exposure",
				"Vehicle Accident",
				"Equipment Failure",
				"Property Damage",
				"Environmental Incident",
				"Theft / Loss of Assets",
				"Security Incident",
				"Data Breach / Cyber Incident",
				"Harassment / Discrimination",
				"Sexual Harassment / Abuse",
				"Violence or Threat",
				"Legal / Regulatory Breach",
				"Policy Violation",
				"Fraud / Corruption",
				"Quality Issue",
				"Customer Complaint",
				"Other"
			],
			rules: {
				required: v => !!v || "This field is required"
			}
		}
	},

	computed: {
		today() {
			return new Date().toISOString().substr(0, 10)
		}
	},

	methods: {
		async send() {
			this.error = null
			if (!this.$refs.form.validate()) return

			this.loading = true
			try {
				await riskAPI.saveIncident(
					localStorage.getItem("incidentClientID"),
					this.form.type,
					this.form.date,
					this.form.description
				)
				this.snackbar = true
				this.$refs.form.reset()
			} catch (err) {
				this.error = err.message || "Could not send the report. Please try again."
			} finally {
				this.loading = false
			}
		},

		logout() {
			localStorage.removeItem("incidentRole")
			localStorage.removeItem("incidentClientID")
			this.$router.push("/incidentreport")
		}
	}
}
</script>

<style scoped>
.header-bar {
	background: linear-gradient(90deg, #6aa9b4 0%, #5f9eab 100%) !important;
}

.header-divider {
	width: 1px;
	height: 26px;
	background: rgba(255, 255, 255, 0.5);
}

.header-title {
	color: #ffffff;
	font-size: 1rem;
	font-weight: 500;
}

.logout-btn {
	color: #ffffff !important;
	border-color: rgba(255, 255, 255, 0.8) !important;
	font-weight: 700;
	letter-spacing: 1px;
}

.page-container {
	max-width: 1400px;
	padding-top: 40px;
}

.page-title {
	color: #3a7a85;
	font-size: 2.4rem;
	font-weight: 700;
	margin-left: 12px;
}

.form-wrapper {
	background: #ffffff;
	padding: 16px;
}

.form-card {
	border: 1px solid #3a3a4a !important;
	background: #ffffff !important;
}

.form-title {
	color: #3b2a4d;
	font-size: 2rem;
	font-weight: 700;
}

.intro-text {
	color: #3b2a4d;
	font-size: 1.05rem;
	line-height: 1.6;
	margin-bottom: 18px;
}

.send-btn {
	background-color: #3a7a85 !important;
	letter-spacing: 1.5px;
	font-weight: 600;
	height: 44px;
}
</style>